export interface QuickReplyOption {
  display: string;
  speech?: string;
  value: string;
}

export function normalizeQuickReply(option: string | QuickReplyOption): QuickReplyOption {
  if (typeof option === 'string') {
    const text = option.trim();
    return { display: text, speech: text, value: text };
  }
  const display = (option.display || option.value || '').trim();
  const value = (option.value || display).trim();
  const speech = (option.speech || display).trim();
  return { display, speech, value };
}

export function normalizeQuickReplies(options?: Array<string | QuickReplyOption>): QuickReplyOption[] {
  if (!options?.length) {
    return [];
  }
  return options.map(normalizeQuickReply);
}

export function quickReplyDisplayLabels(options?: Array<string | QuickReplyOption>): string[] {
  return normalizeQuickReplies(options).map((option) => option.display);
}

export function quickReplySendValue(option: string | QuickReplyOption): string {
  return normalizeQuickReply(option).value;
}
